import Config from "Config";
import axiosCalls from "global/util/axiosCalls";
import LogfileDTO from "./dto/LogfileDTO";

const LogfileService = {
  loadByFilters: (
    automatSerienNr: string,
    datumVon: string, // format dd.MM.YYYY
    datumBis: string, // format dd.MM.YYYY
    kategorien: string,
    callbackOnSuccess: Function,
    callbackOnFail?: Function
  ) => {
    axiosCalls
      .sendGet(`${Config.logfileServiceUrl}logfile/load`, {
        params: {
          automatSerienNr: automatSerienNr,
          datumVon: datumVon,
          datumBis: datumBis,
          kategorien: kategorien,
        },
      })
      .then((response) => {
        callbackOnSuccess(LogfileDTO.convertLogfileResponse(response));
      })
      .catch((error) => {
        if (callbackOnFail) callbackOnFail(error);
      });
  },
};
export default LogfileService;
